import { navigation, variantProvider } from '@/app'
import { LearnGroup } from '@/types'
import { Text, Touchable, Image, PersonaCard } from '@/components'
import React from 'react'
import { arePropsEqual, assignTextStyle } from '@codeleap/common'

type LearnGroupCardProps = {
  item: LearnGroup
  onPress?: (item: LearnGroup) => void
}

const LearnGroupCardComponent = ({ item, onPress }: LearnGroupCardProps) => {
  // @ts-ignore
  if (item.id === 'personalized_content') return <PersonaCard item={item} onPress={onPress} />

  return (
    <Touchable
      style={[styles.container, { backgroundColor: item.bg_color }]}
      onPress={() => onPress?.(item)}
      debugName='LearnGroups:Touchable'
    >
      <Text text={item.title} style={styles.title} />
      <Image source={item.thumbnail} style={styles.image} />
    </Touchable>
  )
}

export const LearnGroupCard = React.memo(LearnGroupCardComponent, (previous, next) => {
  return arePropsEqual(previous, next, { check: ['item'] })
})

const styles = variantProvider.createComponentStyle(theme => ({
  container: {
    width: 'auto',
    height: 'auto',
    ...theme.presets.row,
    ...theme.spacing.paddingVertical(2.5),
    ...theme.spacing.paddingHorizontal(2),
    borderRadius: theme.borderRadius.small,
    ...theme.presets.justifySpaceBetween,
    boxShadow: '0px 24.05px 24.05px rgba(153, 153, 153, 0.2)',
    [theme.media.down('mid')]: {
      maxWidth: '100%',
    },
  },
  title: {
    ...assignTextStyle('h4')(theme).text,
    fontWeight: '700',
    ...theme.presets.alignSelfStart,
    ...theme.spacing.marginTop(-1),
    color: theme.colors.neutral1,
  },
  image: {
    width: 86,
    height: 85,
    objectFit: 'cover',
  },
}), true)
